<template>
  <Primary :items="posts" />
</template>

<script setup>
const props = defineProps({
  posts: {
    type: Object,
    required: true,
  },
});

// Dynamically import the Download component
const Primary = defineAsyncComponent(() =>
  import(`@/components/apps/accordion/PrimaryAPI.vue`)
);
</script>
